const ADMIN_ROOT = "/admin";
const PROFILE_ROOT = "/profile";
const PROFILE_MEMBERS_ROOT = `${PROFILE_ROOT}/members`;

export const ROOT = ADMIN_ROOT;
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const CHANGE_PASSWORD = "/change-password";

export const HOME = ADMIN_ROOT;
export const LECTURES = "/lectures";
export const LECTURES_CREATE = "/lectures/create";
export const LECTURES_EDIT = "/lectures";
export const CATEGORY = "/category";
export const CATEGORY_EDIT_CELL = "/category-edit-cell";
export const CATEGORY_TAB = "/category-tab";
export const DOCUMENT = "/document";

export const ADMIN_SYSTEM = `${ADMIN_ROOT}/quan-tri-he-thong`;
export const DANH_SACH_THANH_VIEN = `${ADMIN_ROOT}/danh-sach-thanh-vien`;
export const NAP_DIEM_THANH_VIEN = `${ADMIN_ROOT}/nap-diem-thanh-vien`;
export const BAN_DIEM_THANH_VIEN = `${ADMIN_ROOT}/ban-diem-thanh-vien`;
export const QUAN_LY_RUT_DIEM = `${ADMIN_ROOT}/quan-ly-rut-diem`;
export const QUAN_LY_MUA_SAN_PHAM = `${ADMIN_ROOT}/quan-ly-mua-san-pham`;
export const DANH_SACH_JOB_XU_LY_THUONG = `${ADMIN_ROOT}/danh-sach-job-xu-ly-thuong`;
export const QUAN_LY_TAI_CAU_TRUC = `${ADMIN_ROOT}/danh-sach-tai-cau-truc`;

const MASTER_ROOT = `${ADMIN_ROOT}/master-root`;
export const CAU_HINH_CHUNG = `${MASTER_ROOT}/cau-hinh-chung`;
export const CAU_HINH_HE_THONG = `${MASTER_ROOT}/cau-hinh-he-thong`;
export const CAU_HINH_TY_LE_THUONG = `${MASTER_ROOT}/cau-hinh-ty-le-thuong`;
export const DANH_SACH_NGAN_HANG = `${MASTER_ROOT}/danh-sach-ngan-hang`;
export const QUAN_TRI_TAI_KHOAN_ADMIN = `${MASTER_ROOT}/quan-tri-tai-khoan-quan-tri`;
export const QUAN_TRI_VAI_TRO = `${MASTER_ROOT}/quan-tri-vai-tro`;
export const QUAN_TRI_QUYEN = `${MASTER_ROOT}/quan-tri-quyen`;

export const PROFILE = PROFILE_ROOT;
export const PROFILE_PURCHASE_PACKAGE = `${PROFILE_ROOT}/purchase-package`;
export const PROFILE_TOPUP = `${PROFILE_ROOT}/topup`;
export const PROFILE_EDIT_INFO = `${PROFILE_ROOT}/edit-info`;
export const PROFILE_POINT_HISTORY = `${PROFILE_ROOT}/point-history`;
export const PROFILE_REWARD_HISTORY = `${PROFILE_ROOT}/reward-history`;
export const PROFILE_MEMBERS = PROFILE_MEMBERS_ROOT;
export const PROFILE_MEMBERS_CREATE = `${PROFILE_MEMBERS_ROOT}/create`;
